export default function initHeader() {
    (function ($) {
        // Handle header scroll behavior
        $(window).on('scroll', function () {
            var scrollPos = $(window).scrollTop();
            if (scrollPos > 1) {
                $('header').addClass('active');
            } else {
                $('header').removeClass('active');
            }
        });

        const menuItems = $('.has-children > .menu-link');
        const $navMenu = $('header nav');
        const $hamburgers = $('#close-hamburger, #open-hamburger');

        // Click event for parent menu items with sub-menus
        menuItems.on('click', function (e) {
            e.preventDefault(); // Prevent the default link action

            // Get the submenu associated with the clicked menu item
            const submenu = $(this).next('.sub-menu');
            const arrow = $(this).find('.submenu-arrow'); // Find the associated arrow

            // Close all other submenus and remove the class from their arrows
            $('.sub-menu').not(submenu).removeClass('show');
            $('.submenu-arrow').not(arrow).removeClass('active'); // Ensure other arrows are reset

            // Toggle the clicked submenu
            submenu.toggleClass('show'); // Toggle visibility of the clicked submenu
            arrow.toggleClass('active', submenu.hasClass('show')); // Add or remove class based on submenu state
        });

        // Click event for actual links (sub-menu links)
        $('.sub-menu .menu-link').on('click', function (e) {
            e.stopPropagation(); // Stop event propagation to avoid unwanted closing
            toggleNav('hide'); // Hide the nav menu when clicking a sub-menu link
        });

        // Function to toggle the nav menu visibility
        function toggleNav(action) {
            if (action === 'show') {
                $navMenu.addClass('active');
            } else {
                $navMenu.removeClass('active');
            }
        }

        // Click event to toggle the nav menu
        $hamburgers.on('click', function (e) {
            e.stopPropagation(); // Prevent the click event from bubbling up
            const isOpen = $(this).is('#open-hamburger');
            toggleNav(isOpen ? 'show' : 'hide'); // Show or hide based on which hamburger is clicked
        });

        // Click event to hide the nav when clicking outside of it
        $(document).on('click', function (e) {
            if (!$navMenu.is(e.target) && $navMenu.has(e.target).length === 0 && !$hamburgers.is(e.target)) {
                toggleNav('hide'); // Hide the nav if the click is outside the nav and hamburgers
            }
        });
    })(jQuery);
}
